import { render, staticRenderFns } from "./navbar-item.vue?vue&type=template&id=4c5d2cab"
import script from "./navbar-item.vue?vue&type=script&lang=js"
export * from "./navbar-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports